
import('/src/v4/kanban.js').then(({ initKanban }) => {
  initKanban();
  // Wire the page-action New card button to open the editor with no preset.
  document.getElementById('kanban-add-btn').addEventListener('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    document.querySelector('.kanban-add[data-add-col="todo"]')?.click();
  });
});
